import getBasePath from '../../functions/api-resource';

const basePath = getBasePath('liquidacao', 'configuracao');

const configuracaoActions = {
  buscarCamposFiltro: { methods: 'GET', url: `${basePath}/campos/filtro/{tipo}` },
};

export default (resource) => resource(`${basePath}`, {}, configuracaoActions);
